import React, { type ReactNode } from 'react'
import { Alert } from 'react-bootstrap'

export interface WarningAlertProps {
  children: ReactNode
}

export const WarningAlert: React.FC<WarningAlertProps> = ({ children }) => (
  <Alert variant='warning' className='bg-warning-subtle rounded-3 border-0 text-bg-warning mb-0 py-2 px-3 small d-flex align-items-center gap-3'>
    <i className='bi bi-exclamation-triangle fs-6 flex-shrink-0' />
    <span>{children}</span>
  </Alert>
)
